import { useLocation, useNavigate } from 'react-router-dom';
import { useUi } from '@/lib/store';

/**
 * t120: return to whatever opened you. A dialog or panel that sends you to a page (e.g. "Plan delivery journey" from
 * a task) passes `openerState(...)` as navigation state; the page's Cancel calls `useBackToOpener(fallback)()`, which
 * goes back to that page and reopens the task panel or person drawer it came from.
 */
export interface Opener { path: string; task?: string; person?: string }

export const openerState = (o: Opener) => ({ opener: o });
export const hereAsOpener = (extra: Omit<Opener, 'path'> = {}): Opener => ({ path: `${window.location.pathname}${window.location.search}`, ...extra });

export function useOpener(): Opener | null {
  const loc = useLocation();
  const o = (loc.state as { opener?: Opener } | null)?.opener;
  return o && typeof o.path === 'string' && o.path.startsWith('/') && !o.path.startsWith('//') ? o : null;
}

export function useBackToOpener(fallback: string) {
  const nav = useNavigate();
  const o = useOpener();
  const openTask = useUi(s => s.openTask);
  const openPerson = useUi(s => s.openPerson);
  return () => {
    if (!o) { nav(fallback); return; }
    nav(o.path, { replace: true });
    if (o.task) setTimeout(() => openTask(o.task!), 0);
    if (o.person) setTimeout(() => openPerson(o.person!), 0);
  };
}
